// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — options.classic.js, новая — options.cp.js
import { isCp } from 'libs/design';
import * as classic from './options.classic';
import * as cp from './options.cp';

export const Options = isCp ? cp.Options : classic.Options;
